// extracted by mini-css-extract-plugin
export default {"scenes-create":"ScenesCreate_scenes-create__Xxy63","scenes-create__wrapper":"ScenesCreate_scenes-create__wrapper__f0-rN"};